export default __webpack_public_path__ + "static/media/team.01e98528.png";